var _rect, _defs, _defs2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1200 900",
    width: 1200,
    height: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 900,
    fill: "#fffdf5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "25%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#fffdf5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#fffdf5",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "75%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "23.333333333333336%",
    stopColor: "#fffdf5",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76.66666666666666%",
    stopColor: "#fffdf5",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1200, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 562.5C-41.2 531 -82.4 499.5 -131.2 489.7C-180 479.9 -236.5 491.8 -271 469.4C-305.5 447 -318.2 390.4 -357.8 357.8C-397.4 325.2 -463.9 316.5 -487.1 281.3C-510.3 246 -490.2 184.1 -495.5 132.8C-500.9 81.5 -531.7 40.7 -562.5 0L0 0Z",
    fill: "#003314"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -562.5C53.6 -566.8 107.2 -571.1 145.6 -543.3C184 -515.6 207.2 -455.7 248.5 -430.4C289.8 -405.1 349.2 -414.4 394.6 -394.6C439.9 -374.8 471.1 -325.9 477.2 -275.5C483.3 -225.1 464.2 -173.2 474.3 -127.1C484.3 -80.9 523.4 -40.5 562.5 0L0 0Z",
    fill: "#003314"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerBackground);
export default __webpack_public_path__ + "static/media/career-background.7190ca2ef2434a362c5c9d5f11e9585e.svg";
export { ForwardRef as ReactComponent };